import { inject, Injectable } from '@angular/core';
import { IdeaPageLoaderService } from '@ideatech/ngx-ideatech';

@Injectable({
    providedIn: 'root',
})
export class HttpLoaderService {

    private ideaPageLoaderService = inject(IdeaPageLoaderService);
    private pendingRequestCount = 0;

    public showLoader(): void {
        this.pendingRequestCount++;
        setTimeout(() => this.ideaPageLoaderService.showPageLoader(), 0)
    }

    public hideLoader(): void {
        this.pendingRequestCount--;
        if (this.pendingRequestCount == 0) {
            setTimeout(() => this.ideaPageLoaderService.hidePageLoader(), 0)
        } else if (this.pendingRequestCount < 0) {
            console.error("[HttpLoaderService]: Pending request count negative!");
        }
    }

}
